module.exports = __webpack_public_path__ + "static/media/rockylinux.1ca8cb65.svg";